import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="cos-e" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <div className="relative">
              <div className="absolute -top-3 -left-3 bg-accent-500 text-white text-xs font-semibold px-4 py-1.5 rounded-full z-10">
                SEO Guide 2026
              </div>
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20minimalist%20fashion%20items%20including%20warm%20sand%20colored%20sneakers%2C%20folded%20camel%20sweater%2C%20small%20tan%20leather%20wallet%2C%20and%20classic%20round%20sunglasses%20on%20warm%20cream%20textured%20surface%2C%20soft%20daylight%20from%20large%20window%2C%20editorial%20catalog%20photography%2C%20neutral%20warm%20aesthetic%2C%20clean%20harmonious%20composition%2C%20no%20text%2C%20no%20people&width=600&height=750&seq=about-itaobuy-spreadsheet-v3&orientation=portrait"
                alt="Itaobuy Spreadsheet guida prodotti"
                className="w-full rounded-2xl"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
              La Guida
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6 leading-tight">
              Cos&apos;è <span className="italic">Itaobuy</span> Spreadsheet?
            </h2>

            <p className="text-foreground-600 text-base leading-relaxed mb-6">
              <strong>Itaobuy Spreadsheet</strong> è uno strumento utilizzato dagli utenti per organizzare e analizzare prodotti attraverso raccolte strutturate di informazioni. Si tratta di fogli di calcolo avanzati che contengono dati dettagliati su migliaia di articoli, permettendo un confronto rapido e una navigazione efficiente tra le diverse categorie merceologiche.
            </p>

            <div className="overflow-x-auto mb-8">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-background-200/70">
                    <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800 bg-background-50 rounded-tl-lg">Elemento</th>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-800 bg-background-50 rounded-tr-lg">Funzione</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-sm text-foreground-700">Nome prodotto</td>
                    <td className="py-3 px-4 text-sm text-foreground-600">Identificazione articolo</td>
                  </tr>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-sm text-foreground-700">Categoria</td>
                    <td className="py-3 px-4 text-sm text-foreground-600">Organizzazione prodotti</td>
                  </tr>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-sm text-foreground-700">Foto QC</td>
                    <td className="py-3 px-4 text-sm text-foreground-600">Valutazione qualità</td>
                  </tr>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-sm text-foreground-700">Prezzo</td>
                    <td className="py-3 px-4 text-sm text-foreground-600">Confronto costo</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 text-sm text-foreground-700">Link prodotto</td>
                    <td className="py-3 px-4 text-sm text-foreground-600">Accesso rapido</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/articoli/itaobuy-spreadsheet-guida-completa"
                className="px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold text-sm rounded-full text-center transition-all whitespace-nowrap cursor-pointer"
              >
                Leggi la guida completa
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold text-sm rounded-full text-center hover:border-foreground-400 transition-all whitespace-nowrap cursor-pointer"
              >
                Vedi su kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}